import { useLazyQuery } from '@apollo/client/react';
import {
  DocumentationCategory,
  DocumentationCategoryFilterInputObject,
  EdmDocumentationCategoriesSearchListQuery,
  EdmDocumentationCategoriesSearchListQueryVariables,
  SortDirectionEnum,
} from 'graphql-common';
import { DEFAULT_SEARCH_LIST_VARIABLES } from '@lib/enums/urls';
import getLoadOptionsResult from '@lib/utils/getLoadOptionsResult';
import createSearchFilters, {
  defaultSearchListSchema,
} from '@lib/utils/createSearchFilters';
import { LoadOptionsParams } from '@lib/components/Select/types';

type FetchLazyQuery = useLazyQuery.ExecFunction<
  EdmDocumentationCategoriesSearchListQuery,
  EdmDocumentationCategoriesSearchListQueryVariables
>;

export const fetchSearchList = async (
  searchQuery: string,
  fetchLazyQuery: FetchLazyQuery,
  page: number,
  additionalFilters?: object[],
) => {
  const options: {
    variables: EdmDocumentationCategoriesSearchListQueryVariables;
  } = {
    variables: {
      ...DEFAULT_SEARCH_LIST_VARIABLES,
      page,
      sorts: { name: SortDirectionEnum.Asc },
    },
  };
  const filters: DocumentationCategoryFilterInputObject[] = [];
  if (searchQuery) {
    filters.push(...createSearchFilters(searchQuery, defaultSearchListSchema));
  }
  if (additionalFilters?.length) {
    filters.push(...additionalFilters);
  }
  if (filters.length) {
    options.variables.filters = filters;
  }
  const { data } = await fetchLazyQuery(options);
  return getLoadOptionsResult(
    data,
    (dataItem: DocumentationCategory) => ({
      value: dataItem.id,
      label: dataItem.name,
      color: dataItem.color,
      allowDownload: dataItem.allowDownload,
      allowPrint: dataItem.allowPrint,
    }),
    searchQuery,
  );
};

export const getDocumentationCategoriesLoadOptions =
  (fetchLazyQuery: FetchLazyQuery, additionalFilters?: object[]) =>
  (searchQuery: string, loadedOptions: unknown, params: LoadOptionsParams) =>
    fetchSearchList(
      searchQuery,
      fetchLazyQuery,
      params?.page || 1,
      additionalFilters,
    );
